<template>
  <div>
    <CCard>
      <CCardBody>
        <div class="coupon-info">
          <!-- <p>coupon: {{coupon}}</p> -->
          <CForm class="member-info modal-form">
            <CRow>
              <CCol lg="6">
                <CInput
                  label="クーポンID"
                  plaintext
                  horizontal
                  v-model="couponId"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <CInput
                  label="クーポン名"
                  plaintext
                  horizontal
                  v-model="coupon.name"
                />
              </CCol>
              <CCol lg="6">
                <!-- <CInput
                  label="利用開始日"
                  plaintext
                  horizontal
                  v-model="coupon.validateSince"
                /> -->
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">利用開始日</label>
                    <div class="col-sm-9">
                      <span>{{
                        coupon.validateSince | formatDate
                      }}</span>
                    </div>
                  </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="6">
                <CInput
                  label="会員カードID"
                  horizontal
                  type="number"
                  v-model="userCardId"
                  plaintext
                />

                <div
                  class="text-danger input-info"
                  v-if="
                    $v.userCardId.$dirty &&
                    (!$v.userCardId.required || !$v.userCardId.minLength)
                  "
                >
                  カードID（16桁）の入力は必須です
                </div>
              </CCol>
              <CCol lg="6">
                <!-- <CInput
                  label="利用終了日"
                  plaintext
                  horizontal
                  v-model="coupon.validateUntil"
                /> -->
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">利用終了日</label>
                    <div class="col-sm-9">
                      <span>{{
                        coupon.validateUntil | formatDate
                      }}</span>
                    </div>
                  </div>
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol lg="6">
                <h5 class="sub-title my-3">オプション</h5>
              </CCol>
            </CRow> -->
            <!-- <p>sum: {{ sumOfTransactions }}</p>
            <p>totalsum: {{ totalsum }}</p> -->
            <!-- <ul v-for="n in coupon.options" :key="n">
              <li>{{ n.reduction }}</li>
            </ul> -->
            <!-- <p>sum amouont: {{ coupon.options }}</p> -->
            <CRow>
              <CCol lg="6">
                <ul>
                  <li>
                    ご家族人数分({{
                      families.length + 1
                    }}名様分)のみオプションを獲得できます
                  </li>
                  <li>
                    例）10時台入館、男性1名、女性3名の場合
                    <ul>
                      <li>10:00～11:00 入館 男性 ⇒ 獲得数:1</li>
                      <li>10:00～11:00 入館 女性 ⇒ 獲得数:3</li>
                    </ul>
                  </li>
                  <li>【凡例】 ○(在庫有り) △(在庫わずか) ×(在庫なし)</li>
                </ul>
                <p>{{coupon.description}}</p>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="">
                <div class="tbl-content">
                  <table class="responsive-table table table-sm">
                    <thead>
                      <tr>
                        <th
                          class="d-sm-down-none sticky-top"
                          width="50"
                          v-if="isOperator()"
                        >
                          No.
                        </th>
                        <th class="sticky-top">オプション名</th>
                        <th class="d-sm-down-none sticky-top">オプション説明</th>
                        <th
                          class="d-sm-down-none sticky-top"
                          v-if="isOperator()"
                        >
                          割引種別
                        </th>
                        <th
                          class="d-sm-down-none sticky-top"
                          v-if="isOperator()"
                        >
                          割引値
                        </th>
                        <th
                          class="d-sm-down-none sticky-top"
                          v-if="isOperator()"
                        >
                          全在庫数
                        </th>
                        <th class="sticky-top">残り在庫</th>
                        <th width="80" class="sticky-top">
                          獲得数
                          <!-- <span>{{ sumOfTransactions }}</span> -->
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(option, n) in coupon.options"
                        :key="option.order"
                      >
                        <td class="d-sm-down-none" v-if="isOperator()">
                          {{ ++n }}
                        </td>
                        <td>{{ option.name }}</td>
                        <td class="d-sm-down-none">{{ option.description }}</td>
                        <td class="d-sm-down-none" v-if="isOperator()">
                          {{ option.type }}
                        </td>
                        <td class="d-sm-down-none" v-if="isOperator()">
                          {{ option.value }}
                        </td>
                        <td class="d-sm-down-none" v-if="isOperator()">
                          {{ option.activations }}
                        </td>
                        <td>{{ getInventoryInfo(option) }}</td>
                        <td>
                          <!-- <CInput
                            size="sm"
                            type="number"
                            v-model="option.reduction"
                          /> -->
                          <!-- TODO: 0～家族人数のプルダウンにする -->
                          <!-- <CSelect 
                            size="sm"
                            type="number"
                            :options="getReductionSelect()"
                            v-model="option.reduction"/> -->
                          <CSelect
                            size="sm"
                            :value.sync="option.reduction"
                            :options="reductionSelection"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CCol>
            </CRow>

            <!-- <CButton @click="cancelCouponN()" color="secondary"
              ><i class="icon cil-x"></i> 戻る</CButton
            > -->
            <CButton
              class="px-4"
              @click="$v.userCardId.$invalid ? requiredFd() : inventoryCoupon()"
              color="success"
              v-bind:class="$v.userCardId.$invalid ? 'inactive' : 'active'"
            >
              <i class="icon cil-save"></i> 獲得
            </CButton>
          </CForm>
        </div>
      </CCardBody>
    </CCard>

    <CButton
      @click="completeClose()"
      class="my-5 btn btn-dark px-5"
    >
      <i class="icon cil-arrow-left"></i> 戻る
    </CButton>

    <!-- success Dialog ↓ -->
    <CModal color="success" size="lg" closeOnBackdrop :show.sync="confirmModel">
      <strong>{{ responseMsg }}</strong>
      <template #header> クーポン獲得成功 </template>
      <template #footer>
        <CButton @click="confirmModel = false" color="danger">閉じる</CButton>
      </template>
    </CModal>
    <!-- Error Dialog start  -->
    <CModal color="danger" size="lg" closeOnBackdrop :show.sync="errorDialog">
      <strong>{{ responseMsg }}</strong>
      <template #header> クーポン獲得失敗 </template>
      <template #footer>
        <CButton @click="errorDialog = false" color="danger" class="px-3"
          >閉じる</CButton
        >
      </template>
    </CModal>

    <!-- success Dialog ↓ -->
    <CModal
      color="success"
      size="lg"
      closeOnBackdrop
      :show.sync="completeModal"
    >
      クーポンの獲得が完了しました。
      <template #header> クーポン獲得完了 </template>
      <template #footer>
        <CButton @click="completeClose()" color="danger">閉じる</CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import { required, numeric, minLength } from "vuelidate/lib/validators";

export default {
  name: "Coupons",
  data() {
    return {
      confirmModel: false,
      errorDialog: false,
      completeModal: false,

      loading: false,
      responseMsg: "",

      couponId: "",
      userCardId: "",
      userName: "",
      linkD: "",

      coupon: {},
      couponG: "",
      couponOptionG: "",
      couponActivations: [],
      isToggled: "",
      totalsum: "",
      selectedOption: false,

      families: [],
      reductionSelection: [],
       
    };
  },

  validations() {
    return {
      userCardId: { required, numeric, minLength: minLength(16) },
    };
  },

  computed: {},

  methods: {
    /**
     * ログインユーザの会員情報を取得
     */
    getUserInformation: function () {
      //Login as registered user
      // var urlRequest = "/rest/currentuser";
      var urlRequest = "/rest/users/" + this.userName;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;
          console.log("User Data:" + JSON.stringify(this.user));

          this.userCardId = this.user.cardId;
          this.getFamilies(this.user.name);
        })
        .catch((err) => {
           
          console.log(err);
        });
    },

    /**
     * 全家族会員の取得
     */
    getFamilies(username) {
      // var urlRequest = "/rest/users/" + this.gUserName + "/relative";
      var urlRequest = "/rest/users/" + username + "/relative";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Families get: ");
          console.log(resp.data);
          this.families = [];
          this.families = resp.data;

          this.reductionSelection = [];
          // bug-2876: オペレータは家族人数の上限なし
          const maxPersons = this.isOperator() ? 100 : this.families.length + 1;
          for (var i = 0; i <= maxPersons; i++) {
            this.reductionSelection.push({ value: i, label: i });
          }
        })
        .catch((err) => {
          console.log("Families get error: " + err);
          this.errors = err;
        });
    },

    /**
     * クーポン情報取得
     */
    getCouponInformation: function () {
      // var urlRequest = "/rest/coupon";
      var urlRequest = "/rest/coupon/" + this.couponId;

      this.loading = false;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.coupon = resp.data;

          // orderでsort
          this.coupon.options.sort((a, b) => {
            return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
          });

          // 獲得数の初期値は0をセット
          this.coupon.options.forEach((a) => (a.reduction = 0));

          this.loading = true;

          console.log("this.coupon");
          console.log(this.coupon);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    /**
     * クーポン発行の在庫引き当て
     */
    inventoryCoupon: function () {
      let sumReduction = 0;
      let options = [];

      // 複数オプションの一括変更
      this.coupon.options.forEach((a) => {
        options.push({
          id: a.id,
          reduction: a.reduction,
        });

        if (a.reduction > 0) {
          sumReduction += parseInt(a.reduction);
        }
      });

      console.log("sumReduction: " + sumReduction);

      if (sumReduction < 1) {
        alert("取得対象のオプションを1件以上指定してください。");
        return;
      }

      if (this.isOperator()) {
        // NOTE: bug-2876 オペレータ操作時は家族人数をチェックしない
      } else if (sumReduction > this.families.length + 1) {
        // 家族数(代表者＋家族)を超過していたらクーポン獲得失敗
        alert("家族人数を超過する組合せの取得はできません。");
        return;
      }

      let data = {
        card: this.userCardId,
        options: options,
      };

      var urlRequest = "/rest/coupon/" + this.couponId + "/inventory";
      this.loading = true;

      axios
        .put(urlRequest, data, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          this.completeModal = true;
          this.responseMsg = "クーポンの獲得に成功しました。";
        })
        .catch((err) => {
          this.responseMsg = err;

          if (err.response.status == 400) {
            // this.cancelCouponN();
            this.responseMsg =
              "ご指定のオプションに空きがないため、クーポンの獲得に失敗しました。\n別の日程をご指定いただき、再度獲得を行ってください。";
          }
          // this.errorMsg = err;
          this.errorDialog = true;
        });
    },

    /**
     * オプション一覧の在庫情報取得
     */
    getInventoryInfo: function (option) {
      const inventory = option.activations - option.activated;

      console.log("inventory: " + inventory);
      if (
        // this.getRole("liberty_operator_admin") ||
        // this.getRole("liberty_operator")
        this.isOperator()
      ) {
        if (inventory < 5) return "×(" + inventory + ")";
        if (inventory < 30) return "△(" + inventory + ")";
        return "○(" + inventory + ")";
      } else {
        if (inventory < 5) return "×";
        if (inventory < 30) return "△";
        return "○";
      }
    },

    /**
     * ロールごとの表示判定用
     *
     * 以下の順番で判定する必要がある。逆から行うと会員が他の権限になるので注意。
     *   1) Admin
     *   2) Operator
     *   3) Member
     */
    getRole: function (navRole) {
      const login_roles = this.$keycloak.realmAccess.roles;
      return login_roles.includes(navRole);
    },

    /**
     * 戻るボタン押下時に戻れるかチェック
     */
    hasHistory() {
      return window.history.length > 2;
    },

    getReductionSelect() {
      return {
        min: 0,
        max: this.families.length,
      };
    },

    completeClose() {
      this.completeModal = false;
      // 1つ前の画面に戻る
      // this.hasHistory() ? this.$router.go(-1) : this.$router.push("/");
      this.linkD == "active-coupon" ? this.$router.push({
        name: "クーポン一覧",
        params: { listTab: 'copon-discount' },
      }) : this.$router.go(-1);
    },

    requiredFd() {
      this.$v.coupon.$touch();
    },

    isOperator() {
      return (
        this.getRole("liberty_operator_admin") ||
        this.getRole("liberty_operator")
      );
    },
  },
  beforeMount() {
    this.getUserInformation();
    this.getCouponInformation();

    // console.log(this.couponId) // 取得OK！
    // TODO: 無効なクーポンは画面表示させない。本来入口がないはずだが、直指定アクセスできてしまうため。

    // TODO: オペレータの表示用(会員コードIDをテキスト、編集可)
    // TODO: 会員の表示用(会員コードIDをラベル、編集不可)
  },
  created() {
    this.couponId = this.$route.params.couponId;
    this.userName = this.$route.params.userName;
    this.linkD = this.$route.params.status;
    // this.userCardId = this.$route.params.userCardId;
  },
};
</script>
